import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var Config = require('../../../../config');

class TransfutionalControl extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.setTable = this.setTable.bind(this);

		this.state = {
			start_date:"",
			end_date:"",
			filename:'Informe Control Transfusional',
			listado:[],
			columns:[
				{title:'', width:'1em'},
				{title:'FECHA', width:'4em'},
				{title:'HORA', width:'3em'},
				{title:'PACIENTE', width:'10em'},
				{title:'NO. PACIENTE', width:'6em'},
				{title:'CAMA', width:'3em'},
				{title:'SERVICIO', width:'5em'},
				{title:'DIAGNOSTICO', width:'10em'},
				{title:'COMPONENTE', width:'6em'},
				{title:'UNIDAD', width:'3em'},
				{title:'VOLUMEN', width:'4em'},
				{title:'FECHA ENVÍO', width:'6em'},
				{title:'HORA ENVÍO', width:'5em'},
				{title:'USUARIO ENVÍO', width:'10em'},
				{title:'FECHA INICIO TRANSFUSIÓN', width:'6em'},
				{title:'HORA INICIO TRANSFUSIÓN', width:'6em'},
				{title:'FECHA FIN TRANSFUSIÓN', width:'6em'},
				{title:'HORA FIN TRANSFUSIÓN', width:'6em'},
				{title:'DOBLE VERIFICACIÓN DE OTRO MEDICO', width:'8em'},
				{title:'DEVOLUCIÓN ENVACE VACIO', width:'7em'},
				{title:'DEVOLUCION IMPRESO CONTROL TRANSFUCIONAL', width:'8em'},
				{title:'MARCADO INCIDENTE TRANSFUCIONAL', width:'8em'},
			],
			date_hour:"",
			medical:"",
			services:[],
			health_services:"all",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=health_services&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({services:response});
			}
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		document.getElementById('start_date').focus();
		this.setTable();
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});			
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
					title: this.state.filename,
					pageSize:'LEGAL',
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							//text:'encabezado',
							alignment:'center',
							width:this.props.w_head
						});

                		doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

						doc.styles.tableHeader.fontSize = 6;
                		doc.defaultStyle.fontSize = 6; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			ordering:false,
			createdRow: (row, data, dataIndex)=>{
				
				
			}	
			
		});

		setTimeout(()=>{
			if (this.state.listado.length === 0 ){// table.rows().indexes().length === 0 ) {
				table.buttons('.buttons-html5').disable();
			}else {
				table.buttons('.buttons-html5').enable();
			}
		}, 500)
		
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date: !this.state.change_check ? this.state.start_date : null,
					end_date: !this.state.change_check ? this.state.end_date : null,
					health_facilities_id:sessionStorage.getItem('health_facilities_id'),
					health_service:this.state.health_services
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/trans_control_report',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: []
						});
						var list = [];
						response.map((r)=>{
							list.push([
								r.consecutive,
								r.petition_date !== null ? moment(r.petition_date).format('DD/MM/YYYY') : "",
								r.petition_hour !== null ? moment(r.petition_hour, 'HH:mm:ss').format('HH:mm') : "",
								r.patient,
								r.patient_number,
								r.bed_number,
								r.service,
								r.diagnosis,
								r.component,
								r.unit,
								r.volume,
								r.register_date !== null ? moment(r.register_date).format('DD/MM/YYYY') : "",
								r.register_hour !== null ? moment(r.register_hour, 'HH:mm:ss').format('HH:mm') : "",
								r.user,
								r.date_start_trans !== null ? moment(r.date_start_trans).format('DD/MM/YYYY') : "",
								r.hour_start_trans !== null ? moment(r.hour_start_trans, 'HH:mm:ss').format('HH:mm') : "",
								r.date_end_trans !== null ? moment(r.date_end_trans).format('DD/MM/YYYY') : "",
								r.hour_end_trans !== null ? moment(r.hour_end_trans, 'HH:mm:ss').format('HH:mm') : "",
								r.double_check,
								r.returned_empty_container,
								r.returned_printed_document,
								r.has_transfusion_incident
							])
								
						});

						

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
							
						}, 1000);

						this.setState({
							listado: list
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{sessionStorage.getItem('health_facilities_name')} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Paciente ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_debts"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
							
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} />
								</div>
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} />
								</div>

								<div className="col-xs-12 form-group">
									<span className="span-min">Servicio</span>
									<select className="form-control" name="health_services" id="health_services"
										value={this.state.health_services || ""} onChange={this.handleChange}>
										<option value="">Seleccione...</option>
										<option value="all">Todos</option>
										{this.state.services.map((f, i)=>{
											return <option key={i} value={f.id}>
												{f.name}
											</option>
										})}
									</select>
								</div>
							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>
								<div className="col-xs-12 form-group">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}}  id="table-to_don" className="expenses-discards" ref={ref => this.el = ref}>
										</table>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}
export default translate('translations')(TransfutionalControl)